import { render } from "./HiveSimpleImagePopUp.vue?vue&type=template&id=5fbd4482"
import script from "./HiveSimpleImagePopUp.vue?vue&type=script&lang=js"
export * from "./HiveSimpleImagePopUp.vue?vue&type=script&lang=js"
script.render = render

export default script